<div class="file-upload" [class.pointers]="allowPointerEvents" [class.file-upload--dragover]="dragOver"
     (dragleave)="onDragLeave($event)"
     (dragover)="onDragOver($event)"
     (drop)="onDrop($event)">
  <div class="file-upload-border">
    <div class="file-upload-border-inner">
      <div class="header">
        <mat-icon class="upload-icon" svgIcon="k12-upload-regular"></mat-icon>
        <p class="title">{{ vm.dropFilesHereText }}</p>
        @if ((configJson?.inputs?.[0]?.['fileType']?.length ?? 0) > 0) {
            <p class="subtitle">
              Supported formats:
              @for (type of configJson?.inputs?.[0]?.['fileType']; track type; let last = $last) {
                {{ type }}@if (!last) {,}
              }
            </p>
        }
        <p class="instructions">- or -</p>
        <button class="browse-for-file" color="primary"
                data-qa="browse-for-file-button"
                data-pw="document-upload-button"
                mat-stroked-button 
                [disabled]="!isEnabled"
                (click)="fileInput.click()">
          Browse for file
        </button>
        <input #fileInput class="input-file" data-pw="document-file-input"
               multiple type="file" 
               [accept]="vm.supportedFileTypes()"
               [attr.id]="'document-file-input'"
               [disabled]="!isEnabled"
               (change)="onSelectedFile($event)"/>
      </div>
    </div>
    <div class="file-size">
      <p>Maximum sizes:&nbsp;{{ configJson?.inputs?.[0]?.fileSize ?? 0 }}mb</p>
    </div>
  </div>

  @if (rejectedFileMessage()) {
    <div class="rejected-files-message" data-qa="rejected-files-message">
      <mat-icon class="warning-icon" svgIcon="k12-warning"></mat-icon>
      <p>{{ rejectedFileMessage() }}</p>
    </div>
  }

  @if (configJson?.inputs?.[0] && vm.files().length > 0 || enrollmentBuilderView) {
    <div class="uploaded-files-container">
      @if (enrollmentBuilderView) {
        <div class="file-item-box layout">
          <div class="file-item-box-details">
            <p class="file-name">File name</p>
            <p class="file-size">
              File 0 of {{ configJson?.inputs?.[0]?.max ?? 0 }} (0mb of 0mb)
            </p>
          </div>
          @if (showUploadProgress) {
            <div class="progress-status">
              <mat-progress-bar class="upload-bar" mode="determinate" [value]="vm.totalSizePercent().toFixed()"></mat-progress-bar>
              <p class="status">{{ vm.totalSizePercent().toFixed() }}%</p>
            </div>
          }
        </div>
      } @else {
        @for (file of vm.files(); track file.name; let i = $index) {
          <div class="file-item-box">
              <div class="file-item-box-details">
                <p class="file-name">{{ file?.name ?? 'File name' }}</p>
                <p class="file-size" [class.text-500]="vm.uploadFailed()">
                  {{ formatFileSize(file?.size || 0) }}mb of {{ configJson?.inputs?.[0]?.fileSize ?? 0 }}mb
                </p>
                @if (vm.uploadFailed()) {
                  <p class="file-message error">Upload failed</p>
                }
                @if (vm.uploadSucceeded()) {
                  <p class="file-message success">File uploaded successfully</p>
                }
              </div>
  
              @if (vm.uploadFailed()) {
                <button data-qa="retry-upload" mat-icon-button matTooltip="Retry upload" (click)="retryUpload()">
                  <mat-icon class="retry-icon" svgIcon="k12-retry"></mat-icon>
                </button>
              }
              @if (vm.uploadSucceeded()) {
                <a class="success-view" tabindex="0" (click)="viewUpload()" (keyup)="viewUpload()">View</a>
              }
              <button class="remove-file-button" data-qa="close-prompt-button" mat-icon-button
                      matTooltip="Remove file" (click)="onRemoveTemplatingFile(file)">
                <mat-icon svgIcon="k12-x-mark"></mat-icon>
              </button>
          </div>
        }
        @if (showUploadProgress) {
          <div class="progress-bar-container">
            <mat-progress-bar class="upload-bar" mode="determinate" [value]="vm.totalSizePercent()"></mat-progress-bar>
              @if (isUploading) {
                <p class="status">Uploading... {{ currentUploadProgress }}%</p>
              } @else {
                <p class="status">{{ vm.totalSizePercent() | number:'1.0-2' }}%</p>
              }
          </div>
        }
      }
    </div>
  }
</div>